/**
 * Die Reiter der Hilfsmittel-Seite (`/dashboard/himi-versorgung?tab=`), als Namen fuer die URL.
 *
 * Bewusst eine **eigene Datei** und keine Konstante in der Seiten-Komponente: `app.routes.ts` und
 * der HiMi-Assistent brauchen die Namen, und ein Import aus der Komponente zoege deren gesamten
 * Baum (Dashboard-Liste, Filter, beide Reiter) in den Start-Chunk — die Route laedt sie sonst lazy.
 *
 * Von 2026-09-09 bis 2026-09-25 stand hier eine Zahl als ID (0–3), nicht als Position: „Hartmann
 * CCaaS" ist bedingt und steht an zweiter Stelle. Alte Zahlen-Links werden seit 2026-10-12 nicht mehr
 * uebersetzt und landen auf dem ersten Reiter. Allgemeines zu Reiter-Namen: `reiterMitUrl` in
 * `libs/shared`.
 */
export const HIMI_TAB = {
  VERSORGUNGEN: 'versorgungen',
  ENTWUERFE: 'entwuerfe',
  BEMUSTERUNGEN: 'bemusterungen',
  CCAAS_ENTWUERFE: 'ccaas-entwuerfe',
} as const
export type HimiTab = (typeof HIMI_TAB)[keyof typeof HIMI_TAB]

/**
 * Die Reiter in ANZEIGEreihenfolge. „Hartmann CCaaS" steht direkt neben „Entwuerfe" — es sind zwei
 * Ansichten derselben Liste, die gehoeren nebeneinander.
 */
export function sichtbareHimiReiter(mitCcaas: boolean): HimiTab[] {
  return mitCcaas
    ? [HIMI_TAB.VERSORGUNGEN, HIMI_TAB.ENTWUERFE, HIMI_TAB.CCAAS_ENTWUERFE, HIMI_TAB.BEMUSTERUNGEN]
    : [HIMI_TAB.VERSORGUNGEN, HIMI_TAB.ENTWUERFE, HIMI_TAB.BEMUSTERUNGEN]
}

/** Deep-Link auf einen Reiter, z. B. fuer `router.navigate(...)` oder eine Weiterleitung. */
export function himiTabUrl(tab: HimiTab): string {
  return `/dashboard/himi-versorgung?tab=${tab}`
}
